// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
export const GroupConversationsStoreActionTypes = [
    ActionType.CleanGroupConversationThreadAction,
    ActionType.CreateGroupConversationThreadAction,
    ActionType.CreateGroupConversationThreadFailedAction,
    ActionType.CreateGroupConversationThreadSucceededAction,
    ActionType.FetchGroupConversationThreadAction,
    ActionType.FetchGroupConversationThreadFailedAction,
    ActionType.FetchGroupConversationThreadSucceededAction,
    ActionType.FetchGroupConversationThreadPostAction,
    ActionType.FetchGroupConversationThreadPostFailedAction,
    ActionType.FetchGroupConversationThreadPostSucceededAction,
    ActionType.PostGroupConversationThreadReplyAction,
    ActionType.PostGroupConversationThreadReplyFailedAction,
    ActionType.PostGroupConversationThreadReplySucceededAction
];
